import React from "react";
import { useNavigate } from "react-router-dom";

import './organizationcard.css';
import capitolImage from "../assets/capitol.png";

export default function OrganizationCard(props) {
    const navigate = useNavigate();

    const handleNavigate = (organization_id) => {
        navigate("/organization/" + organization_id);
    }

    const formatPhoneNumber = (phone) => {
        if (!phone) return '';
        const cleaned = ('' + phone).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        return phone; // fallback if it doesn't match expected pattern
    }

    return (
        <>
            <div key={props.organization_id} className="card organization-card m-2" onClick={() => handleNavigate(props.organization_id)}>
                <div className="row g-0">
                    <div className="col-sm-4 col-3">
                        <img src={props.logo || capitolImage} 
                            className="card-img organization-card-image" 
                            alt={"Logo for " + props.organization_name}
                        />
                    </div>
                    <div className="col-sm-8 col-9">
                        <div className="card-body org-card-body ps-2 pb-2">
                            <h6 className="card-title organization-card-name display-6 mb-1"><strong>{props.organization_name}</strong></h6>
                            {props.suite ? (
                                <p className="org-city-state pt-0 mb-2">{props.street_address}, Suite {props.suite}<br/> {props.city}, {props.state}</p>
                            ) : (
                                <p className="org-city-state pt-0 mb-2">{props.street_address}<br/> {props.city}, {props.state}</p>
                            )}
                            
                            {props.main_phone && (
                                <p className="org-main-phone">Phone: {formatPhoneNumber(props.main_phone)}</p>
                            )}
                            
                        </div>
                    </div>
                </div>
               
                
            </div>
           
           
        </>
    )
}